<mat-dialog-content
  >@if (data) {
  <app-dynamic-table
    [tableProps]="data.content"
  ></app-dynamic-table>
}
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>
